import {
  useLocation as useRRLocation,
  useNavigate as useRRNavigate,
} from "react-router";

const useNavigate = () => {
  const navigate = useRRNavigate();
  const { search } = useRRLocation();

  return (path, options) => {
    navigate(path + search, options);
  };
};

export default useNavigate;
